/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
const GI = {

  bindSidebar:function(openSelector, closeSelector, sidebarSelector){
    const $sidebar = $(sidebarSelector);

    $(openSelector).on('click',function(){
      $('#menu-sidebar, #info-sidebar').not($sidebar).removeClass('active');
      $sidebar.addClass('active');
    })

    $(closeSelector).on('click',function(){
      $sidebar.removeClass('active');
    })

    $sidebar.on('click',function(event){
      if (event.target === this) {
        $sidebar.removeClass('active');
      }
    })
  },
  menuSidebar:function(){
    GI.bindSidebar('#menu-open', '#menu-close', '#menu-sidebar');
  },
  infoSidebar:function(){
    GI.bindSidebar('#info-open', '#if-close', '#info-sidebar');
  },
  cartSidebar:function(){
    document.addEventListener('theme:cart:open',function(){
      $('#menu-sidebar, #info-sidebar').removeClass('active');
    })
  },
  formatProductPrices:function(root){
    root.querySelectorAll('.product__price [data-product-price], .product__price [data-compare-price]').forEach(function(price){
      const formattedPrice = price.textContent.replace(/,/g, '').replace(/₹\s*/g, 'R');

      if (price.textContent !== formattedPrice) {
        price.textContent = formattedPrice;
      }
    });
  },
  productPrices:function(){
    GI.formatProductPrices(document);

    document.addEventListener('theme:variant:change',function(event){
      GI.formatProductPrices(event.target);
    });
  }

}

document.addEventListener('DOMContentLoaded',function(){
  GI.menuSidebar();
  GI.infoSidebar();
  GI.cartSidebar();
  GI.productPrices();
});
